<template>
  <div class="info-container" ref="infoContainerRef">
    <a class="info-item" target="_blank" :href="termsService" @click="handleClose">
      <span>用户协议</span>
      <span class="hitems-arrow-right"></span>
    </a>
    <a class="info-item" target="_blank" :href="privacyPolicy" @click="handleClose">
      <span>隐私政策</span>
      <span class="hitems-arrow-right"></span>
    </a>

    <div class="social-media">
      <div class="social-media-item" v-for="item in socialMediaList" :key="item.id">
        <span :class="item.icon"></span>
        <div class="media-img-box">
          <span class="tips">扫码添加{{ item.name }}</span>
          <img :src="item.imgPath" :alt="item.name" class="media-img" />
        </div>
      </div>
    </div>

    <div class="info-text-container">
      <div class="info-text" v-for="item in infoText" :key="item.id">
        <span>{{ item.text }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, onUnmounted } from 'vue'
  import imgGroupChat from '@/assets/images/qrcode/official-wechat.webp'
  import imgXiaohongshu from '@/assets/images/about/xiaohongshu.webp'
  import imgGongzhonghao from '@/assets/images/about/weixin.webp'
  import imgMiniProgram from '@common/assets/images/wechat-qrcode.webp'

  defineOptions({
    name: 'CompanyInfo'
  })

  const emit = defineEmits(['close'])

  const privacyPolicy =
    'https://zaohaowu.com/docs/%E7%94%A8%E6%88%B7%E9%9A%90%E7%A7%81%E5%8D%8F%E8%AE%AE'
  const termsService =
    'https://zaohaowu.com/docs/%E5%B9%B3%E5%8F%B0%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE'

  const infoContainerRef = ref<HTMLDivElement>()

  const socialMediaList = [
    {
      id: 1,
      name: '官方群聊',
      icon: 'hitems-chat-group',
      imgPath: imgGroupChat
    },
    {
      id: 2,
      name: '小红书',
      icon: 'hitems-xiaohongshu',
      imgPath: imgXiaohongshu
    },
    {
      id: 3,
      name: '官方公众号',
      icon: 'hitems-wechat',
      imgPath: imgGongzhonghao
    },
    {
      id: 4,
      name: '小程序',
      icon: 'hitems-miniprogram',
      imgPath: imgMiniProgram
    }
  ]

  const infoText = [
    {
      id: 1,
      text: '京ICP备2025113650号-1'
    },
    {
      id: 2,
      text: '数美万物（北京）网络技术有限公司，是全球首创一站式AI造物平台'
    },
    {
      id: 3,
      text: '联系方式：18929571267'
    },
    {
      id: 4,
      text: '地址：北京市海淀区丹棱街1号院1号楼12层1203'
    },
    {
      id: 5,
      text: '增值电信业务经营许可证(跨地区)：合字B2-20250166'
    }
  ]

  const handleClickOutside = (e: MouseEvent) => {
    const moreInfoBtn = document.getElementById('header-more-info')
    if (
      infoContainerRef.value &&
      !infoContainerRef.value.contains(e.target as Node) &&
      !moreInfoBtn?.contains(e.target as Node)
    ) {
      emit('close')
    }
  }

  onMounted(() => {
    document.addEventListener('click', handleClickOutside)
  })

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
  })

  const handleClose = () => {
    emit('close')
  }
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
